/**
 * @desc 学期总览
 */

const termSynopsis = (r) =>
  require.ensure(
    [],
    () => r(require('../views/synopsis/TermSynopsis.vue')),
    'termSynopsis'
  )

//今日详情
const today = (r) =>
  require.ensure(
    [],
    () => r(require('../views/synopsis/Today.vue')),
    'today'
  )

/**
 * @desc 日运营汇总
 */

const dailyOperations = (r) =>
  require.ensure(
    [],
    () => r(require('../views/synopsis/DailyOperations.vue')),
    'dailyOperations'
  )
export default [
  //订单
  {
    name: 'termSynopsis',
    path: '/termSynopsis',
    component: termSynopsis,
    meta: { title: '学期总览' },
  },
  //今日详情
  {
    name: 'today',
    path: '/today',
    component: today,
    meta: { title: '今日', keepAlive: true },
  },
  {
    name: 'DailyOperations',
    path: '/DailyOperations',
    component: dailyOperations,
    meta: { title: '日运营汇总' },
  },
]
